{
	"tabs": {
		"resume": "Cierre",
		"promotion": "Promociones utilizadas",
		"debtors": "Cuentas abiertas",
		"devolution": "Devolución de tarjeta por caja",
		"cashierClosings": "Cierre de caja",
		"userBonus": "Bonos",
		"discounts": "Descuentos en cuenta",
		"minimumConsumption": "Consumo anticipado",
		"consumptionObligation": "Consumo Mínimo",
		"refunded": "Productos reembolsados",
		"servicesRemoval": "Servicios eliminados",
		"bonusByProduct": "Bonos por producto",
		"rechargeConsumption": "Devolución de recargas",
		"refundedRecharges": "Recargas reembolsadas",
		"individualLimitPost": "Cambio de límite individual de post",
		"rappiDiscounts": "Descuentos Rappi",
		"openedBillPayment": "Pagos de cuentas abiertas",
		"openSales": "Ventas individuales",
		"afterClosingEvent": "Acciones sincronizadas después del evento",
		"cashierAdjustments": "Sangrías y Fondos de Cambio",
		"forciblySynchronizedBalances": "Saldos Sincronizados Forzadamente",
		"zigAppReport": "Ventas por transacciones del Zig.app",
		"tipReport": "Reporte de Propina",
		"transactionTransfer": "Transferencias de cuentas"
	},
	"resumeReport": {
		"title": "Cierre",
		"finished": {
			"end": "Cerrado: {{end}}h",
			"not": "El evento no ha sido cerrado"
		},
		"reportIn": "Facturación del evento '{{eventName}}'",
		"fileName": "facturacion-{{eventName}}"
	},
	"debtorsReport": {
		"title": "Cuentas abiertas",
		"modal": {
			"confirm": "Confirmar",
			"yes": "Sí",
			"no": "No",
			"paymentMethodError": "Seleccione un método de pago",
			"pay": "Pagar",
			"placeScope": "local",
			"eventScope": "evento",
			"paymentConfirm_part1": "Este pago ",
			"paymentConfirm_part2": "pagará TODA la deuda",
			"paymentConfirm_part3": "del cliente en el {{scope}}, ¿está seguro que desea hacer esto?",
			"paymentMethod": "Método de pago",
			"postEvent": "Marcar como pagado",
			"bonus": "Pagar con bono",
			"cash": "Efectivo",
			"creditCard": "Crédito",
			"debitCard": "Débito",
			"voucher": "Voucher",
			"multiplePaymentConfirm_part1": "Este pago ",
			"multiplePaymentConfirm_part2": "pagará {{value}}",
			"multiplePaymentConfirm_part3": "del cliente en el {{scope}}, ¿está seguro que desea hacer esto?",
			"multiplePaymentError": "¡Atención! Agregue un método de pago",
			"column": {
				"bonus": "Bono",
				"value": "Valor"
			},
			"openConsumption": "Consumo abierto",
			"total": "Total",
			"service": "Servicio ({{tip}}%)",
			"paymentConsumption": "Pagando en consumo",
			"paymentService": "Pagando en servicio",
			"submitError": "Solo es posible pagar hasta 25% más del valor total abierto.",
			"select": "Seleccione",
			"addPayment": "Agregar pago",
			"reason": "Justificación",
			"reasonPlaceholder": "Agregue la justificación del bono",
			"observation": "Observación",
			"observationPlaceholder": "Ingrese una observación",
			"pixCharge": "Cobro vía PIX",
			"sendCharge": "Enviar cobro",
			"openValues": "Valores abiertos",
			"totalDebit": "Total abierto",
			"pixValue": "Valor del pix",
			"email": "Correo electrónico",
			"emailPlaceholder": "Correo electrónico del cliente",
			"fieldRequired": "Campo obligatorio",
			"emailError": "Correo electrónico inválido",
			"phoneError": "Teléfono inválido",
			"discharge": "Dar de baja",
			"openService": "Servicio abierto"
		},
		"alertTitleOpenBill": "No es posible enviar cobros en el reporte del evento",
		"alertMessageOpenBill": "Para enviar cobros, acceda al menú [Locales] > elija el local > menú [Reportes Financieros] > pestaña 'Cuentas abiertas' y utilice el enlace en la columna 'Cobrar'."
	},
	"cashierClosings": {
		"card": {
			"total": "TOTAL",
			"closed": "Cerrado",
			"open": "Abierto",
			"received": "Facturado",
			"difference": "Diferencia",
			"casher_one": "{{numberOfCashiers}} Caja",
			"cashier_other": "{{numberOfCashiers}} Cajas",
			"notClosed_one": "({{numberOfOpenCashiers}} no cerrado)",
			"notClosed_other": "({{numberOfOpenCashiers}} no cerrados)",
			"modality": "Modalidad",
			"noFlag": "Sin Bandera",
			"cash": "Efectivo",
			"cardDevolution": "Devoluciones de tarjeta",
			"productDevolution": "Devoluciones de producto",
			"bleeding": "Sangría",
			"changeFund": "Fondo de cambio",
			"rechargeDevolutions": "Devoluciones de recarga",
			"xlsx": {
				"modality": "Modalidad",
				"received": "Facturado",
				"closed": "Cerrado",
				"difference": "Diferencia",
				"closingResume": "Resumen del Cierre",
				"cashier": "Caja",
				"closingCashier": "Cierre por Caja",
				"filenameEvent": "cierre-de-caja-{{eventDate}}",
				"filename": "cierre-de-caja-en-local"
			}
		},
		"header": {
			"cashierHistory": "Ver historial de caja",
			"transactionalHistory": "Ver historial transaccional",
			"addBleed": "Hacer sangría",
			"addChange": "Agregar fondo de cambio",
			"reopenCashier": "¿Está seguro que quiere reabrir la caja?",
			"reopenCashierButton": "Reabrir caja",
			"closeCashier": "¿Está seguro que desea cerrar la caja {{cashierName}}?",
			"closeCashierButton": "Cerrar caja",
			"historyTitle": "Historial de caja - {{cashierName}}",
			"obs": "Observación",
			"addObs": "Agregar observación"
		},
		"modal": {
			"cashiers": "Cajas",
			"value": "Valor",
			"changeFund": "Fondo de cambio",
			"history": "Historial",
			"historyTitle": "Historial de {{name}}",
			"cashierPosts": "Transacciones post-pago",
			"cashierRecharges": "Recargas",
			"addFlag": "Agregar bandera",
			"saveValues": "Guardando valores",
			"column": {
				"client": "Cliente",
				"clients": "Cliente(s)",
				"zigCode": "ZigTag",
				"date": "Fecha",
				"method": "Método",
				"valueRecharged": "Valor recargado",
				"valueComsumed": "Valor consumido",
				"total": "Total",
				"payments": "Pagos",
				"author": "Empleado",
				"obs": "Observación"
			}
		},
		"valueGreaterThanZero": "El valor debe ser mayor que 0",
		"value": "Valor",
		"cashier": "Cajas",
		"noCard": "Sin tarjeta",
		"noCashierSelected": "Ninguna caja seleccionada",
		"all": "Todas",
		"total": "Total",
		"info": {
			"closingCashier": "Cierre de caja",
			"cashierReceipt": "Ingreso por caja",
			"changeFund": "Fondo de cambio",
			"changes": "Cambio",
			"cashier_one": "caja",
			"cashier_other": "cajas",
			"notClosed": "no cerrado",
			"billed": "Facturado",
			"bleeds": "Sangrado",
			"devolutions": "Devuelto",
			"closed": "Cerrado",
			"negative": "Diferencia",
			"searchCashier": "Buscar caja por nombre",
			"cashierNotClosed": "Caja no cerrada",
			"createBleed": "Hacer Sangría",
			"createChange": "Agregar fondo de cambio",
			"bleeding": "Sangría",
			"cardDevolution": "Devoluciones de tarjeta",
			"rechargeDevolutions": "Devoluciones de recarga",
			"addNewModality": "Agregar nueva modalidad",
			"closeCashier": "Cerrar caja",
			"cancel": "Cancelar cambios",
			"save": "Guardar cierre",
			"modality": "Modalidad",
			"totalClosed": "Total Cerrado",
			"totalBilled": "Total Facturado"
		},
		"paymentMethod": {
			"debit": "Débito",
			"cash": "Efectivo",
			"credit": "Crédito",
			"zigDebit": "Débito Zig",
			"zigCredit": "Crédito Zig",
			"postEvent": "Pagado después del evento",
			"voucher": "Voucher",
			"dashboard": "Panel",
			"anticipated": "Anticipado",
			"subtotal": "Subtotal",
			"devolution": "Devoluciones",
			"total": "Total",
			"ame": "Ame",
			"deliveryOnline": "Delivery Online",
			"rappi": "Rappi",
			"ifood": "Ifood",
			"uber": "Uber",
			"pix": "Pix",
			"bonus": "Bono",
			"installment": "Pago en cuotas",
			"foodVoucher": "Vale de Alimentación",
			"online": "En línea",
			"mbway": "MBWay"
		},
		"transactionsTitle": "Historial de {{name}}",
		"postPaid": "Transacciones post-pago",
		"recharges": "Recargas",
		"balanceTitleDay": "Ingreso por caja en el día {{day}}",
		"balanceTitle": "Ingreso por caja",
		"filenameBalance": "ingreso_por_caja"
	},
	"minimumConsumption": {
		"title": "Consumo anticipado"
	},
	"refunded": {
		"title": "Productos reembolsados/cancelados",
		"filename": "productos-reembolsados",
		"zigTable": "Mesa Zig",
		"zigTag": "Tarjeta Zig",
		"zigFicha": "Ficha Zig",
		"columns": {
			"date": "Fecha",
			"name": "Nombre del Producto",
			"category": "Categoría",
			"type": "Tipo",
			"canceled": "Cancelado",
			"refunded": "Reembolsado",
			"refundedBy": "Reembolsado Por",
			"soldBy": "Vendido Por",
			"refundObs": "Observación",
			"reason": "Motivo",
			"clients": "Clientes",
			"operationType": "Operación",
			"count": "Cantidad",
			"value": "Valor",
			"totalRefunded": "Total ({{total}} reembolsos)",
			"totalValue": "Valor Total",
			"totalCount": "Cantidad Total",
			"moreRefundedBuyer_other": "y {{buyers}} personas más",
			"moreRefundedBuyer_one": "y {{buyers}} persona más"
		}
	},
	"servicesRemoval": {
		"title": "Eliminación de servicios por caja",
		"titlePrint": "Servicios Eliminados",
		"goTo": "ir a",
		"clientInfo": "Información del Cliente",
		"columns": {
			"date": "Fecha",
			"total": "Total Eliminado",
			"name": "Cliente",
			"value": "Valor",
			"reason": "Motivo",
			"employee": "Empleado"
		}
	},
	"rechargeConsumption": {
		"title": "Devolución de recargas",
		"filename": "devolucion-de-recargas",
		"detailDialog": "Ver recargas devueltas por caja",
		"rechargesRefundedBy": "Recargas devueltas por {{author}}",
		"columns": {
			"author": "Caja",
			"ame": "Ame",
			"anticipated": "Anticipado",
			"cash": "Efectivo",
			"credit": "Crédito",
			"dashboard": "Panel",
			"debit": "Débito",
			"deliveryOnline": "Delivery Online",
			"ifood": "Ifood",
			"pix": "PIX",
			"rappi": "Rappi",
			"uber": "Uber",
			"voucher": "Voucher",
			"total": "Total",
			"client": "Cliente",
			"method": "Método",
			"value": "Valor",
			"integratedFoodVoucher": "Vale de Alimentación",
			"zigPosCreditInInstallments": "Crédito en cuotas"
		}
	},
	"individualLimitPost": {
		"title": "Información de clientes",
		"titleTab": "Cambio de límite individual de post",
		"searchPlaceholder": "Buscar por usuario, id o nombre",
		"filename": "reporte_de_cambio_de_limite_individual_de_post",
		"columns": {
			"username": "Usuario",
			"client": "Cliente",
			"employeeName": "Empleado",
			"date": "Horario",
			"limit": "Aumento de límite",
			"newLimite": "Nuevo límite",
			"emptyText": "Sin datos para mostrar."
		}
	},
	"rappiDiscounts": {
		"title": "Descuentos de Rappi",
		"rappiDiscounts": "Descuentos Rappi",
		"filename": "reporte_de_descuentos_de_rappi",
		"columns": {
			"products": "Productos",
			"date": "Fecha",
			"value": "Valor del descuento",
			"employee": "Empleado que aplicó el descuento"
		}
	},
	"openedBillPayment": {
		"title": "Pagos de cuentas abiertas",
		"filename": "reporte_de_pagos_de_cuentas_abiertas_en_evento",
		"columns": {
			"client": "Cliente",
			"document": "RFC",
			"openedEventDate": "Fecha de la cuenta abierta",
			"employeeName": "Pagado a",
			"method": "Método",
			"tipValue": "Valor de propina",
			"value": "Valor"
		}
	},
	"afterClosingEvent": {
		"title": "Acciones sincronizadas después del evento",
		"description": "Reporte con acciones o transacciones después del cierre del evento.",
		"searchLabel": "Buscar por nombre del empleado",
		"searchPlaceHolder": "Ingrese el nombre del empleado",
		"filterTransactionLabel": "Filtrar por tipo de transacción",
		"filterOriginLabel": "Visualizar",
		"offlineActionLabel": "Después del cierre",
		"historyMachineLabel": "Historial de la term.",
		"historyMachineAfterClosingLabel": "Historial después del cierre",
		"optionAll": "Todos los saldos",
		"optionOfflineAction": "Saldos sincronizados después del cierre de evento",
		"optionHistoryMachine": "Saldos del historial de la terminal",
		"optionHistoryMachineAfterClosing": "Saldos del historial de la terminal sincronizados después del cierre del evento",
		"columns": {
			"transactionType": "Tipo de transacción",
			"employee": "Empleado",
			"customerName": "Nombre del cliente",
			"date": "Fecha/Hora de sinc",
			"value": "valor",
			"origin": "Origen"
		}
	},
	"forciblySynchronizedBalance": {
		"title": "Saldos Sincronizados Forzadamente",
		"table": {
			"columns": {
				"date": "Fecha/Hora",
				"user": "Cliente",
				"employee": "Empleado",
				"reason": "Justificación",
				"balance": "Saldo Sincronizado"
			}
		},
		"successfulExportMsg": "¡Hoja de cálculo exportada con éxito!"
	},
	"zigAppReport": {
		"title": "Ventas por transacciones del Zig.app"
	},
	"salesTotetemTransaction": {
		"title": "Ventas por transacciones del Tótem",
		"subtitle": "Monitoree las transacciones realizadas por sus clientes usando un tótem del evento."
	}
}
